import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { QueryClient, QueryClientProvider } from "react-query";
import { Provider as StoreProvider } from "react-redux";
import { getGlobalStore } from "@jti/commerce/shared";
import { store } from "@jti/store";
import { LocaleContext } from "@jti/ui";
import { AppRunner } from "./components/AppRunner";
import { RootContainer } from "./containers/RootContainer";
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: false,
        },
    },
});
export const CartMiniApp = ({ globalStoreResolved }) => {
    return (_jsx(StoreProvider, { store: globalStoreResolved ? getGlobalStore() : store, children: _jsx(LocaleContext.Provider, { value: "en-US", children: _jsxs(QueryClientProvider, { client: queryClient, children: [_jsx(AppRunner, {}), _jsx(RootContainer, {})] }) }) }));
};
//# sourceMappingURL=CartMiniApp.js.map